export function OutlinePowerIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1082 5.9032C18.9174 7.35668 20.0704 9.57741 20.0704 12.0602C20.0704 16.4445 16.4714 19.9996 12.0328 19.9996C7.59426 19.9996 4 16.4397 4 12.0555C4 9.57264 5.15306 7.35192 6.96225 5.89844"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.0378 3V11.9401"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
